var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-tab",class:{
    sticky: _vm.sticky
  },style:({
    top: _vm.sticky ? _vm.offsetTop + 'px' : ''
  })},[_c('div',{staticClass:"lyf-ui-tab-inner"},[_c('div',{ref:"lyfUiTabItemsRef",staticClass:"lyf-ui-tab-items",class:{
        'scrollable': _vm.tabs.length > 4,
        'widest': _vm.tabs.length > 8
      }},_vm._l((_vm.tabs),function(tab,idx){return _c('div',{key:idx,staticClass:"lyf-ui-tab-item",class:{
          active: idx === _vm.value
        },style:({
          color: idx === _vm.value ? _vm.activeColor : ''
        }),on:{"click":function($event){return _vm.tabItemClick(idx)}}},[_vm._v(_vm._s(tab)+" "),_c('div',{staticClass:"lyf-ui-tab-line",style:({
            color: _vm.activeColor,
            backgroundColor: _vm.activeColor
          })})])}),0)]),(_vm.tabs.length > 8)?_c('div',{staticClass:"lyf-ui-tab-more"},[_c('lyf-icon',{attrs:{"icon":"list1","size":22}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }